export const ANALYTICS = {
  ADD_TO_BASKET: 'addToBasket',
  UPDATE_BASKET_ITEM: 'updateBasketItem',
  BASKET_CREATED: 'basketCreated',
  BASKET_CLEARED: 'basketCleared',
  BASKET_REFRESHED: 'basketRefreshed',
  //Product Option Selector
  PRODUCT_OPTION_SELECTOR_OPEN: 'productOptionsViewedPlp',
  PRODUCT_OPTION_SELECTOR_SELECTED: 'productOptionSelectedPlp',
} as const;

export const CONTENT_TYPES = {
  PRODUCT: 'product',
} as const;

export const CURRENCY_CODES = {
  THB: 'THB',
} as const; 